<template>
    <div>
        <div>
            <b-form-row>
                <b-col>
                    <h5>EYPR-Data Performance</h5>
                </b-col>
            </b-form-row>
            <fieldset :disabled="formDisabled">
                <div class="section-line" />
                <b-form-row>
                    <b-col>
                        <b-table
                            :items="applicationPerkinsPerformance"
                            striped
                            small
                            bordered
                            :fields="coreIndicatorTable"
                            :disabled="formDisabled"
                            @saveForm="saveForm"
                        >
                            <template v-slot:cell(indicatorDisplayName)="data">
                                {{ data.item.indicatorDisplayName }}
                            </template>

                            <template v-slot:cell(priorPerformance)="data">
                                {{ (data.item.priorPerformanceEyprData + '%') || 'Loading...' }}
                            </template>

                            <template v-slot:cell(target)="data">
                                {{ (data.item['targetAy' + targetAy] + '%') || 'Loading...' }}
                            </template>

                            <template v-slot:cell(improvementPlanYear)="data">
                                {{ data.item.improvementPlanYear }}
                            </template>
                        </b-table>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            1P1: Retention/Placement<br>
                            Analyze your own data to see if there are any issues
                            to be addressed for each of your performance indicators.
                        </div>
                        <b-form-textarea
                            v-model="textbox1p"
                            :disabled="formDisabled"
                            :rows="3"
                        />
                    </b-col>
                </b-form-row>
                <br>
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            2P1: Credential Attainment<br>
                            Analyze your own data to see if there are any issues
                            to be addressed for each of your performance indicators.
                        </div>
                        <b-form-textarea
                            v-model="textbox2p"
                            :disabled="formDisabled"
                            :rows="3"
                        />
                    </b-col>
                </b-form-row>
                <br>
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            3P1: Nontraditional Participation<br>
                            Analyze your own data to see if there are any issues
                            to be addressed for each of your performance indicators.
                        </div>
                        <b-form-textarea
                            v-model="textbox3p"
                            :disabled="formDisabled"
                            :rows="3"
                        />
                    </b-col>
                </b-form-row>
                <br>
            </fieldset>
        </div>
        <!-- <div class="dotted-rule"></div> -->
        <div>
            <b-form-row>
                <b-col>
                    <b-button
                        xblock
                        data-toggle="tooltip"
                        data-placement="left"
                        title="Save Eypr Data"
                        variant="primary"
                        class="w-50 ace-purple"
                        :disabled="formDisabled"
                        :is-loading="isSaving"
                        @click="saveForm"
                    >
                        <fa-icon :icon="['fas', 'save']" /> Save
                    </b-button>
                </b-col>
            </b-form-row>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
    name: 'PerformanceDetails',

    props: {},

    data() {
        return {
            coreIndicatorTable: [
                { key: 'indicatorDisplayName', label: 'Core Indicator' },
                { key: 'priorPerformance', label: 'Prior Performance' },
                { key: 'target', label: 'Upcoming AY Target' },
                { key: 'improvementPlanYear', label: 'Improvement Plan Status' },
            ],

            isSaving: false,
        };
    },

    computed: {
        ...mapState('ref/perkinsIndicators', {
            perkinsIndicatorPerformance: 'perkinsPerformanceWithIndicatorDetails',
        }),

        ...mapState('eyprData/form', {
            eyprDataAy: (state) => state.academic_year,
            applicantId: (state) => state.applicant_id,
            eyprDataTextbox1p: (state) => state.content.explanation1P1,
            eyprDataTextbox2p: (state) => state.content.explanation2P1,
            eyprDataTextbox3p: (state) => state.content.explanation3P1,
        }),

        ...mapGetters({
            isReviewer: 'auth/isReviewer',
            eyprDataFormContent: 'eyprData/form/eyprDataFormContent',
            isEyprDataEditable: 'eyprData/isEditable',
            currentAy: 'ref/global/currentAy',
        }),

        targetAy() {
            return (Number(this.eyprDataAy) + 1);
        },

        formDisabled() {
            return !this.isEyprDataEditable;
        },

        applicationPerkinsPerformance() {
            if (this.isReviewer) {
                return this.perkinsIndicatorPerformance.filter((indicator) => {
                    return indicator.applicantId === this.applicantId;
                });
            }

            return this.perkinsIndicatorPerformance;
        },

        indicatorTargets: {
            get() { return this.eyprDataFormContent.indicatorTargets; },
            set(v) { this.updateIndicatorTarget(v); }
        },

        textbox1p: {
            get() { return this.eyprDataTextbox1p; },
            set(value) { this.updateEyprData({ field: 'content', value: { explanation1P1: value } }); },
        },

        textbox2p: {
            get() { return this.eyprDataTextbox2p; },
            set(value) { this.updateEyprData({ field: 'content', value: { explanation2P1: value } }); },
        },

        textbox3p: {
            get() { return this.eyprDataTextbox3p; },
            set(value) { this.updateEyprData({ field: 'content', value: { explanation3P1: value } }); },
        },

    },

    methods: {
        ...mapActions({
            updateEyprData: 'eyprData/form/update',
            updateIndicatorTarget: 'eyprData/form/updateIndicatorTarget'
        }),

        blurCheck($event) {
            $event.target.reportValidity();
        },

        async saveForm() {
            this.isSaving = true;
            // if (this.saveValidation) {
            this.$emit('save:eyprData:performance');
            // }
            this.isSaving = false;
        },
    },
};
</script>
<style scoped lang="scss">
@import "$StyleVars";

h5 {
    font-size: 1.5rem;
    text-align: left;
    font-weight: bold;
    color: $ace-purple;
}
.field-labels {
    font-size: 1rem;
    font-weight: bold;
    text-align: left;
    color: $ace-purple;
    margin-bottom: .25rem;
}
</style>
